import { Box } from '@atgfr8/atg-ui-tailwind';
import { ConfigManager } from '@utils/ConfigManager';
import { CustomerHeader } from '@views/customer/CustomerHeader';

import { CustomerGrid } from './CustomerGrid';

const Customer = () => {
  return (
    <>
      {ConfigManager.showLayout && <CustomerHeader title={'Customers'} />}
      <Box class="rounded-md! p-2 h-[calc(100%-73px)]! overflow-y-auto! bg-[#E1ECF2]">
        <CustomerGrid />
      </Box>
    </>
  );
};

export default Customer;
